<template>
  <div class="form-group">
    <label :for="textareaId" class="label">{{ label }}</label>
    <textarea
      :name="name"
      class="textarea"
      :id="textareaId"
      :placeholder="placeholder"
      :value="value"
      :class="{'textarea_large' : large, 'textarea_error': error}"
      @input="$emit('input', $event.target.value)">
    </textarea>
    <span v-show="error" class="error-text">Incorrect!</span>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    value: String,
    label: String,
    textareaId: String,
    large: Boolean,
    error: Boolean,
    name: String,
  },
};
</script>

<style lang="scss" scoped>
.textarea {
  font-family: Montserrat;
  outline: none;
  padding: 0%;
  background: rgba(0, 0, 0, 0.05);
  border: none;
  border-radius: 4px;
  font-size: 14px;
  color: $black-color1;
  padding: 12px 20px;
  min-height: 60px;
  resize: none;
  border: 1px solid transparent;
  &::placeholder {
    color: $grey-color1;
  }
  &_large {
    max-width: 510px;
    width: 100%;
    min-height: 132px;
    padding: 16px 20px;
  }
}
.label {
  @include label;
}
.form-group {
  position: relative;
}
.textarea_error {
  border: 1px solid $red-color3;
}
.error-text {
  @include font(13px, $red-color3);
  font-weight: 500;
  display: block;
  text-align: right;
  position: absolute;
  right: 0;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/uikit/TextareaEl.vue